import api, { API } from "@/lib/api";
import { shouldPersistTracking } from "@/lib/consent";

let ephemeralSid = null;

function publishSid(sid) {
  // Envoyé dans X-Session-Id sur chaque appel API (blocage par appareil côté backend)
  try { api.defaults.headers.common["X-Session-Id"] = sid; } catch { /* ignore */ }
  return sid;
}

export function getSessionId() {
  const uuid = () => (typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`);
  if (!shouldPersistTracking()) {
    if (!ephemeralSid) ephemeralSid = uuid();
    return publishSid(ephemeralSid);
  }
  let s = localStorage.getItem("lumiere_sid");
  if (!s) {
    s = uuid();
    localStorage.setItem("lumiere_sid", s);
  }
  return publishSid(s);
}

let lastEnter = null;
let lastPath = null;
let exitBound = false;

function kindFor(pathname) {
  if (pathname.startsWith("/produit/")) return { kind: "product", slug: pathname.split("/produit/")[1] };
  if (pathname.startsWith("/categorie/")) return { kind: "category", slug: pathname.split("/categorie/")[1] };
  return { kind: "page", slug: null };
}

function bindExit() {
  if (exitBound || typeof window === "undefined") return;
  exitBound = true;
  const sendExit = () => {
    if (!lastEnter || !lastPath) return;
    const dwell = Date.now() - lastEnter;
    const { kind, slug } = kindFor(lastPath);
    const body = JSON.stringify({
      path: lastPath, kind, slug, type: "exit",
      session_id: getSessionId(), dwell_ms: dwell,
      title: typeof document !== "undefined" ? document.title : null,
    });
    try {
      if (navigator.sendBeacon) {
        navigator.sendBeacon(`${API}/track`, new Blob([body], { type: "application/json" }));
      }
    } catch (e) {
      /* ignore */
    }
    lastEnter = null;
  };
  window.addEventListener("pagehide", sendExit);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") sendExit();
  });
}

export function trackView(pathname) {
  bindExit();
  const { kind, slug } = kindFor(pathname);
  const dwell = lastEnter ? Date.now() - lastEnter : null;
  api.post("/track", {
    path: pathname,
    kind,
    slug,
    type: "view",
    session_id: getSessionId(),
    ref: document.referrer || null,
    title: typeof document !== "undefined" ? document.title : null,
    dwell_ms: dwell,
    screen: typeof window !== "undefined" ? `${window.screen?.width}x${window.screen?.height}` : null,
  }).catch(() => {});
  lastEnter = Date.now();
  lastPath = pathname;
}

export function trackEvent(type, data = {}) {
  api.post("/track", {
    path: typeof window !== "undefined" ? window.location.pathname : "/",
    kind: "event",
    type,
    session_id: getSessionId(),
    ...data,
  }).catch(() => {});
}
